import React, { useContext } from "react";
import { paddingModalStyles } from "@futures-platform/ui";
import Modal from "./Modal";
import { requestTranslation } from "@futures-platform/i18n";
import { finalTranslations } from "../../localTranslation";
import styled, { createGlobalStyle } from "styled-components";
import ThumbUp from "../Thumbs/ThumbUp";
import { translateCommentSections } from "../../helpers/utils";
import EditCommentModal from "../EditCommentModal/EditCommentModal";
import edit2 from "./edit2.svg";
import { capitalizeFirstLetter } from "../../helpers/utils";
import { ACTIONS } from "../../store/Actions";
import { DataContext } from "../../store/GlobalState";
import { commentingApi } from "../../helpers/commentingFetcher";
import { dispatchCardAction } from '../../utils/postMessageUtils';
import clsx from "clsx";
import { v4 as uuid } from "uuid";
import {
  getUserRoles,
  getVisitorUid,
} from "@futures-platform/connectors/session";
import styles from "./CommentsModal.module.css";
const GlobalStyle = createGlobalStyle`
  .ReactModal__Overlay--after-open {
    background-color: rgba(0,0,0,.77)!important;
    z-index: 100;
    // width: 600px;
  }
  #commentsModal .ReactModal__Content__Wrapper_Comments {
    position: relative;
    // background-color: rgb(255, 255, 255);
    background-color: #e8ebeb !important;
    margin: 0 auto;
    // max-width: 600px;
    font-family: L10;

    font-size: 1.6rem;
    // width: 70%;
  }
  #commentsModal .form-control{
    font-size: 1.6rem;
  }
  .btn-close-modal {
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: rgb(0, 105, 152);
    position: absolute;
    top: -15px;
    right: -15px;
    color: rgb(255, 255, 255);
    line-height: 30px;
    vertical-align: middle;
    text-align: center;
  }

  .btn-close-modal .material-icons {
    font-size: 20px;
    display: inline-block;
    line-height: inherit;
  }

  #commentsModal input:focus, #commentsModal textarea:focus {
    outline: none !important;
    // border: 1px solid #d5dbdf;
  }

  /* Mobile-specific fixes - ONLY for comments modal */
  @media (max-width: 768px) {
    #commentsModal input, #commentsModal textarea {
      position: relative !important;
      z-index: 1000 !important;
      -webkit-user-select: text !important;
      user-select: text !important;
      pointer-events: auto !important;
      -webkit-touch-callout: default !important;
      -webkit-tap-highlight-color: rgba(0,0,0,0.1) !important;
      transform: translateZ(0) !important;
      will-change: transform !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      border-radius: 0 !important;
      background: white !important;
      // border: 1px solid #ccc !important;
      padding: 12px !important;
      margin: 4px 0 !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }
    
    #commentsModal input:focus, #commentsModal textarea:focus {
      z-index: 1001 !important;
      position: relative !important;
      // outline: 2px solid #007cba !important;
      // border: 2px solid #005a87 !important;
      // background: #f8f9fa !important;
    }
    
    /* Prevent zoom on iOS - ONLY for comments modal */
    #commentsModal input, #commentsModal textarea {
      font-size: 16px !important;
    }
    
    /* Ensure modal content doesn't interfere - ONLY for comments modal */
    #commentsModal .ReactModal__Content {
      overflow: visible !important;
    }
    
    /* Force input behavior - ONLY for comments modal */
    #commentsModal input[type="text"], #commentsModal textarea {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
      cursor: text !important;
      -webkit-appearance: textfield !important;
    }
  }
`;
const MAXCHARS = 1000;
const CommentsModal = ({
  commentsModal,
  commentsModalClose,
  commentTopic,
  gid,
  rid,
  pid,
  phenomenon,
  cmts,
  lang,
  likingOn,
}) => {
  const {
    state: { cmtsData, groupRadarIdGlobalState },
    dispatch,
  } = useContext(DataContext);

  const { translationTitle } = translateCommentSections(commentTopic, lang);
  const [openEditCommentModal, setOpenCommentsModal] = React.useState(false);
  const [currentCmtIsHandling, setCurrentCmtIsHandling] = React.useState(null);
  const [valueInput, setValueInput] = React.useState("");
  const [valueInputName, setValueInputName] = React.useState("");
  const [remainingChars, setRemainingChars] = React.useState(
    MAXCHARS - +"".length
  );
  const [isLoadingSubmit, setIsLoadingSubmit] = React.useState(false);

  const openEditCommentModalHandle = (cmt) => () => {
    setOpenCommentsModal(true);
    setCurrentCmtIsHandling(cmt);
  };
  // http://fp_commenting.localhost/commenting/290/radar/195080/phenomenon/c4ad9b29-6d99-465d-b68e-315c90015e66/opportunities/c1f9d794-e658-4845-89fb-00b29524d136
  // commentId: "8134cc4f-b196-43e5-9b8e-c460fc8bfb02"
  // upsertComment: async (gid, radarId, pid, section, cmtId, payload)
  const commentsModalSubmit = async () => {
    if (!!valueInput?.length) {
      setIsLoadingSubmit(true);
      const resNewCmt = await commentingApi.upsertComment(
        groupRadarIdGlobalState || gid,
        rid,
        pid,
        commentTopic?.toLowerCase(),
        uuid(),
        {
          text: valueInput,
          name: valueInputName,
        }
      );
      const resGetAllCmtsByPhenId = await commentingApi.getAllCommentsByPhenId(
        groupRadarIdGlobalState || gid,
        rid,
        pid
      );

      dispatch({
        type: ACTIONS.CMTSDATA,
        payload: [...resGetAllCmtsByPhenId?.data],
      });
      dispatchCardAction('comment_submit', {
        gid: groupRadarIdGlobalState || gid,
        radarId: rid,
        phenomenonId: pid,
        section: commentTopic?.toLowerCase(),
        commentId: resNewCmt?.data?.comment_id,
        text: valueInput,
        name: valueInputName,
      });
      setIsLoadingSubmit(false);
      // commentsModalClose()
      setValueInput("");
      setValueInputName("");
      setRemainingChars(MAXCHARS);
    }
  };

  const functionFromRadatComment = (value) => {
    setOpenCommentsModal(value);
  };
  const closeEditCommentModalHandle = () => {
    setOpenCommentsModal(false);
  };
  const checRemainingCharsInput = (value) => {
    var textAreaValue = +value.length;
    var charactersLeft = MAXCHARS - textAreaValue;
    return Number(charactersLeft);
  };
  const handleChangeInput = (e) => {
    const tempInputValue = e.target.value;
    const remainingChars = checRemainingCharsInput(tempInputValue);
    setRemainingChars(() => remainingChars);
    setValueInput(() => tempInputValue);
  };
  const handleChangeInputInput = (e) => {
    const tempInputValue = e.target.value;
    setValueInputName(() => tempInputValue);
  };

  const getFp_Vid_fromLocalStorage = localStorage.getItem("fp-vid");
  const userRoles = getUserRoles();
  let isAdminUser = false;
  for (const [key, value] of Object.entries(userRoles[0])) {
    if (
      value?.includes("authenticated user") ||
      value?.includes("administrator") ||
      value?.includes("alternative futures") ||
      value?.includes("fp admin") ||
      value?.includes("fp manager") ||
      value?.includes("superuser") ||
      value?.includes("fp editor") ||
      value?.includes("fp csm")
    ) {
      isAdminUser = true;
    }
  }
  const isVisitorFP = getVisitorUid();
  const isShownInputNameField =
    !!getFp_Vid_fromLocalStorage || !!isVisitorFP || !!isAdminUser;
  return (
    <>
      <GlobalStyle />
      <Modal
        id="commentsModal"
        onRequestClose={commentsModalClose}
        isOpen={commentsModal}
        contentLabel="radar-modal"
        ariaHideApp={false}
        style={paddingModalStyles}
      >
        <div
          className={clsx(
            styles.commentsModalWrapper,
            "confirmation-modal-content"
          )}
        >
          <h1 className={styles.h1Title}>{phenomenon?.short_title}</h1>
          {/* messageModal */}
          <div className={styles.cmtArea}>
            <p className={styles.cmtTitle}>{translationTitle}</p>
            {/* showChat */}
            <div className={styles.showingCommentsArea}>
              <>
                {!!cmts?.length &&
                  cmts?.map((cmt, index) => {
                    const cmtId = cmt?.comment_id;
                    return (
                      <>
                        {!!cmt && index !== 0 && <hr />}
                        <div className={styles.eachCmtWrapper}>
                          <div className={styles.eachCmtContainer}>
                            <div className={styles.cmtInfo}>
                              <div className={styles.userNameWrapper}>
                                <span>
                                  {capitalizeFirstLetter(
                                    !!cmt?.["comment_name"]
                                      ? cmt?.["comment_name"]
                                      : cmt?.["user_name"] ||
                                          requestTranslation("visitor")
                                  )}
                                </span>{" "}
                                <span className={styles.timeStampText}>
                                  {cmt?.["updated_humanTime"]}
                                </span>
                              </div>
                              <div className={styles.verticalLine}></div>
                              {!!likingOn && (
                                <ThumbUp
                                  cid={cmtId}
                                  gid={groupRadarIdGlobalState || gid}
                                  rid={rid}
                                  pid={pid}
                                  size={"20"}
                                  view={"thumb_up"}
                                />
                              )}
                            </div>
                            {!!cmt?.["isAuthor"] && (
                              <EditButton
                                src={edit2}
                                onClick={openEditCommentModalHandle(cmt)}
                              />
                            )}
                          </div>
                          <p className={styles.cmtText}>
                            {cmt?.["comment_text"]}
                          </p>
                        </div>
                      </>
                    );
                  })}
              </>
            </div>
          </div>
          <div>
            <div className="form-group">
              {isShownInputNameField && (
                <input
                  type="text"
                  placeholder={
                    lang === "fi"
                      ? finalTranslations?.name?.fi
                      : finalTranslations?.name?.en
                  }
                  className={styles.inputStyle}
                  onChange={handleChangeInputInput}
                  value={valueInputName}
                  autoComplete="off"
                  inputMode="text"
                  enterKeyHint="next"
                  style={{
                    fontSize: "16px",
                    position: "relative",
                    zIndex: 1000,
                    WebkitUserSelect: "text",
                    userSelect: "text",
                    pointerEvents: "auto",
                    WebkitTouchCallout: "default",
                    transform: "translateZ(0)",
                    WebkitAppearance: "none",
                    appearance: "none",
                    cursor: "text",
                    touchAction: "manipulation",
                  }}
                  onTouchStart={(e) => {
                    e.stopPropagation();
                    e.target.focus();
                  }}
                  onTouchEnd={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.target.focus();
                  }}
                  onFocus={(e) => {
                    e.target.style.zIndex = "1001";
                    setTimeout(() => {
                      e.target.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                    }, 300);
                  }}
                />
              )}
              <textarea
                style={{
                  fontSize: "16px",
                  resize: "vertical",
                  overflowY: "auto",
                  height: "76px",
                  position: "relative",
                  zIndex: 1000,
                  WebkitUserSelect: "text",
                  userSelect: "text",
                  pointerEvents: "auto",
                  WebkitTouchCallout: "default",
                  transform: "translateZ(0)",
                  WebkitAppearance: "none",
                  appearance: "none",
                  cursor: "text",
                  touchAction: "manipulation",
                }}
                onChange={handleChangeInput}
                maxLength="1000"
                className={clsx(styles.textAreaStyle, "form-control")}
                id="comment_textarea"
                value={valueInput}
                placeholder={
                  lang === "fi"
                    ? `${finalTranslations?.message?.fi} *`
                    : `${finalTranslations?.message?.en} *`
                }
                autoComplete="off"
                inputMode="text"
                enterKeyHint="send"
                rows="3"
                onTouchStart={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                onTouchEnd={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  e.target.focus();
                }}
                onFocus={(e) => {
                  e.target.style.zIndex = "1001";
                  setTimeout(() => {
                    e.target.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }, 300);
                }}
              />
              <div className={styles.btnGroup}>
                <label
                  htmlFor="example1"
                  style={{
                    fontSize: "12.5px",
                    color: "#333",
                    marginBottom: 0,
                  }}
                >
                  {remainingChars}{" "}
                  {lang === "fi"
                    ? finalTranslations?.charactersRemainingText?.fi
                    : finalTranslations?.charactersRemainingText?.en}
                </label>
                <div className="">
                  <button
                    data-title={phenomenon?.title}
                    data-action-id="comment"
                    data-comment-text={valueInput}
                    data-comment-name={valueInputName}
                    data-comment-topic={commentTopic}
                    className={clsx(
                      styles.btnFontSize,
                      "btn btn-sm btn-primary"
                    )}
                    onClick={
                      isLoadingSubmit || !valueInput?.length
                        ? null
                        : commentsModalSubmit
                    }
                    disabled={isLoadingSubmit || !valueInput?.length}
                  >
                    {lang === "fi"
                      ? finalTranslations?.submitCommentModal?.fi
                      : finalTranslations?.submitCommentModal?.en}
                  </button>
                  <button
                    onClick={commentsModalClose}
                    className={clsx(styles.btnFontSize, "btn btn-sm btn-plain")}
                  >
                    {lang === "fi"
                      ? finalTranslations?.cancel?.fi.toUpperCase()
                      : finalTranslations?.cancel?.en.toUpperCase()}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <EditCommentModal
        id="editCommentModal"
        isOpenEditCommentingModal={openEditCommentModal}
        onClosemodal={closeEditCommentModalHandle}
        data={currentCmtIsHandling}
        lang={lang}
        functionFromRadatComment={functionFromRadatComment}
      />
    </>
  );
};

export default CommentsModal;

export const EditButton = styled.img`
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
`;
